import { render, staticRenderFns } from "./LayoutManagerParent.vue?vue&type=template&id=0626ce42&scoped=true"
import script from "./LayoutManagerParent.vue?vue&type=script&lang=js"
export * from "./LayoutManagerParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626ce42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0626ce42')) {
      api.createRecord('0626ce42', component.options)
    } else {
      api.reload('0626ce42', component.options)
    }
    module.hot.accept("./LayoutManagerParent.vue?vue&type=template&id=0626ce42&scoped=true", function () {
      api.rerender('0626ce42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/parent/manager/LayoutManagerParent.vue"
export default component.exports